import { Controller } from '@hotwired/stimulus'
import { filter } from 'lodash-es'

export default class extends Controller {
  static targets = ['enabler', 'dependent']

  connect() {
    this.toggle()
    this.dependentCheckboxes().forEach((elem) => {
      elem.addEventListener('change', this.preventLockedCheck.bind(this))
    })
  }

  toggle() {
    if (!this.hasEnablerTarget) {
      return
    }

    if (this.enablerTarget.checked) {
      this.lockDependents()
    } else {
      this.unlockDependents()
    }
  }

  unlockDependents() {
    this.dependentCheckboxes().forEach((elem) => {
      elem.closest('label').classList.remove('color-grey')
    })
  }

  lockDependents() {
    this.dependentCheckboxes().forEach((elem) => {
      elem.closest('label').classList.add('color-grey')
      elem.checked = this.enablerTarget.checked
    })
  }

  preventLockedCheck(e) {
    if (this.hasEnablerTarget && this.enablerTarget.checked) {
      e.currentTarget.checked = true

      e.preventDefault()
      e.stopImmediatePropagation()
    }
  }

  dependentCheckboxes() {
    return filter(this.dependentTargets, { type: 'checkbox' })
  }

}
